import React, { FC, memo } from 'react';

import { useTranslation } from 'react-i18next';

import styles from './AuthPageTitle.module.scss';

interface AuthPageTitleProps {
    titleKey: string;
}

const AuthPageTitle: FC<AuthPageTitleProps> = ({ titleKey }) => {
    const { t } = useTranslation();

    return (
        <h1 className={styles.title}>
            {t(titleKey)}
        </h1>
    );
};

export default memo(AuthPageTitle);
